import React from 'react'
import ModalBox from '../../components/modal/ModalBox'
import useButtonLoader from '../../hooks/UseButtonLoader'
import toast from 'react-hot-toast'
import { changeUserStatusApi } from '../../services/userManagement'

const ChangeUserStatus = ({ show, close, status, id, listing, userName }) => {
    const [buttonref, buttonLoader] = useButtonLoader("Yes")

    //--------------change-status-Product-------------------------
    const changeStatus = async () => {
        try {
            buttonLoader(true)
            let data = ({ status: !status, id: id })
            const res = await changeUserStatusApi(data)
            if (res.data.status === 200) {
                toast.success(res.data.message)
                close()
                buttonLoader(false)
                listing()

            } else {
                toast.error(res.data.message)
                buttonLoader(false)
            }
        } catch (e) {
            toast.error(e.message)
            buttonLoader(false)
        }
    }
    return (
        <ModalBox
            status={show}
            onClose={close}
            title={`${status ? "Block" : "Unblock"} User`}
            description={
                <span>
                    Do you want to {status ? "block" : "unblock"} <strong>{userName}</strong> ?
                </span>
            }
            action={changeStatus}
        // ref={buttonref}
        />
    )
}

export default ChangeUserStatus